export default "/images/marketo.svg?7c944d37d330c8e1b68868ca279de37e";